﻿
    <template>
       
        <v-card fluid width="100vw">
            <v-dialog persistent v-model="dialogConfirmSaveVariables" max-width="500">
                <v-card class="mx-auto">
                    <v-toolbar color="blue" dark>
                        <v-toolbar-title>Confirmación</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text class="pb-0">
                        <v-row align="center" class="mx-0 mt-4">
                        </v-row>
                        <div class="my-4 subtitle-1 black--text">
                            A continuación se editaran las variables editadas y/o borradas. <br /> ¿Desea Continuar?
                        </div>

                    </v-card-text>

                    <v-card-actions class="px-6 pb-6">
                        <v-spacer></v-spacer>
                        <v-btn text small @click="dialogConfirmSaveVariables=false;">
                            NO
                        </v-btn>
                        <v-btn color="blue" dark small @click="saveDataVariables()">
                            SI
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog persistent v-model="dialogAddVariable" max-width="500">
                <v-form ref="formAddVariable" class="slim">
                    <v-card class="mx-auto">
                        <v-toolbar color="blue" dark>
                            <v-toolbar-title>{{itemVariable ? itemVariable.name : ''}}</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-card-text class="pb-0">
                            <v-row align="center" class="mx-0 mt-4">
                            </v-row>
                            <div class="my-4 subtitle-1 black--text">
                                <strong>Editar nombre de la variable</strong>
                                <v-row style="margin-top: 5px;">
                                    <v-col sm="12" md="12">
                                        <v-text-field class="pr-3 mx-280" v-model="itemVariable.nameNew" label="Nombre Variable" clearable outlined dense :rules="reglaNameNew" @keyup.enter="addVariable()"></v-text-field>
                                    </v-col>
                                </v-row>
                            </div>

                        </v-card-text>

                        <v-card-actions class="px-6 pb-6">
                            <v-spacer></v-spacer>
                            <v-btn text small @click="dialogAddVariable=false">
                                Cancelar
                            </v-btn>
                            <v-btn color="blue" dark small @click="addVariable()">
                                Aceptar
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>
            <v-container class="d-flex pt-2 flex-wrap justify-center">
                <template v-if="!selectionVariables.length" class="item-font" style="font-weight: 300">
                    <br />
                    Seleccione primero el Supervisor para ver los Elementos existentes.
                </template>
                <template v-else>
                    <v-row>
                        <v-col class="pa-0" cols="12" align="right" v-if="listItemSelected.length>0" style="margin-top: 15px">
                            <v-btn large dark small color="blue" @click="dialogConfirmSaveVariables=true;">
                                Guardar cambios
                            </v-btn>
                            &nbsp;
                            <v-btn large dark small color="blue" @click="reset()">
                                Cancelar Cambios
                            </v-btn>
                        </v-col>
                        <v-col cols="5" class="pl-0">
                            <v-card-title class="justify-center" style=" background-color: lightgray !important; padding: 4px;">
                                Elementos Disponibles
                            </v-card-title>
                            <v-treeview :key="index" :items="selectionVariables"
                                        activatable
                                        active-class="primary--text"
                                        class="grey lighten-5 item-font"
                                        open-on-click
                                        transition
                                        dense
                                        style="padding-top: 10px">
                                <template v-slot:label="{ item }">
                                    <div v-if="item.level!==2 && item.level!==4" class="treeview-item">{{ item.name }}</div>
                                    <div v-if="item.level===2" style="left:-2px; position:relative">                                       
                                            <v-icon class="menu-icon small" color="red" @click="removeItem(item)" v-if="!item.deleted">
                                                mdi-trash-can
                                            </v-icon>
                                            <v-icon class="menu-icon small" color="green" @click="openDialogAddVariable(item)" v-if="!item.deleted">
                                                mdi-file-document-edit
                                            </v-icon>                                      
                                        {{ item.name }}
                                    </div>
                                    
                                    <div v-if="item.level===4" style="left:2px; position:relative">
                                        <v-icon class="menu-icon small" color="red" @click="removeItem(item)" v-if="!item.deleted">
                                            mdi-trash-can
                                        </v-icon>
                                        <v-icon class="menu-icon small" color="green" @click="openDialogAddVariable(item)" v-if="!item.deleted">
                                            mdi-file-document-edit
                                        </v-icon>
                                        {{ item.name }}
                                    </div>
                                </template>

                            </v-treeview>

                        </v-col>
                        <v-col cols="7" class="pl-0">
                            <v-card-title class="justify-center" style=" background-color: lightgray !important; padding: 4px;">
                                Elementos y/o Variables a Modificar o Borrar
                            </v-card-title>
                            <template v-if="listItemSelected.length===0" class="item-font" style="font-weight: 200; font-size: 7px;">
                                <p style="margin-left: 20px;">
                                    <br />
                                    No hay variables en esta lista.
                                    <br />
                                </p>
                            </template>
                            <v-list>

                                <v-list-group v-for="item in listItemSelected" :key="item.name" v-model="item.active" no-action sub-group>

                                    <template v-slot:activator>

                                        <v-list-item-content>                                           
                                            
                                            {{ item.name}}  {{item.modified ?'(modificar)':''}}

                                        </v-list-item-content>
                                        <span style="font-size: 12px">{{ item.path }}</span><v-icon class="menu-icon small" color="red" v-if="(item.modified||item.deleted)" @click="cancelEdicionElemento(item)">
    mdi-undo
</v-icon>
                                    </template>

                                    <v-list-item-group class="pl-10">

                                        <v-list-item v-for="child in item.variables" :key="child.id" sub-group>

                                            <v-list-item-content style="padding-top: 4px">

                                                <v-list-item-title style="font-size: 14px">
                                                    <v-icon class="menu-icon small" color="red" @click="cancelEdicionVariable(child)">
                                                        mdi-undo
                                                    </v-icon>
                                                    {{ child.name}} <span style="font-size: 12px; float: right">{{ child.path }}</span>    {{child.deleted ? '(borrar)' : '(modificar)'}}
                                                </v-list-item-title>

                                            </v-list-item-content>

                                        </v-list-item>

                                    </v-list-item-group>

                                </v-list-group>
                            </v-list>

                        </v-col>


                    </v-row>

                </template>
            </v-container>
        </v-card>
    </template>

<script>
    
    import {
        Component,
        Prop,
        Vue,
        Watch
    } from "vue-property-decorator";
    
    import 'vue2-datepicker/index.css';    
    import VariableService from "../services/VariableService";

    @Component({
        components: {
        
        },
        
        props: {           
            selectionVariables: {
                default: [],
                type: Array
            },
            idNSupervisor: {
                default: 0,
                type: Number
            }

        }
    })
    export default class TabIzqElementos extends Vue {   
        dialogAddVariable = false;
        dialogConfirmSaveVariables = false;
        selectionVariablesOriginal = [];
        itemVariable = {
            id: null,
            name: null,
            nameNew: null,
            original:null,
            modified: null,
            deleted: null,            
        };
        listItemSelected = [];
        index = 0;

        sendMessageToParent() {
            this.$emit('messageFromChild');
        }

        openDialogAddVariable(item) {            
            this.$data.dialogAddVariable = true;
            this.$data.itemVariable = item;
            this.$data.itemVariable.nameNew = item.name; 
            this.$data.itemVariable.original = item.name; 
            this.$data.itemVariable.modified = false;  
            this.$data.itemVariable.deleted = false;
            this.$data.itemVariable.level = item.level;
            
        }  
        /**
         * Busqueda recursiva para el level 2 y el item.id
         * @param arrayObject
         * @param item
         */
        searchNodeGrandFather(arrayObject, item) {
            const objNode = arrayObject.find(elem => elem.level === 2 && elem.id === item.id);
            if (objNode) {
                return objNode;
            }
            for (const node of arrayObject) {
                if (node.children) {
                    var rtn = this.searchNodeGrandFather(node.children, item);
                    if (rtn != null) {
                        return rtn;
                    }
                }
            }
        }
        reset() {
            this.$props.selectionVariables = JSON.parse(JSON.stringify(this.$data.selectionVariablesOriginal));
            this.listItemSelected = [];
        }
        /**
         * Wizard. Carga inicial del lado derecho. Cuando no hay elementos
         * @param arrayObject
         * @param item
         */
        recursiveAddVariable(arrayObject, item, nameGrandFather, pathName) {

            const objElemen = arrayObject.find(elem => elem.level === 3 && elem.id === item.idNAgrupacionVariable && elem.parentId === item.idNTipoElemento);
            if (objElemen) {
                item.name = item.nameNew;
                item.route = item.Path;

                //Si el Abuelo Existe en el lado derecho              
                const grandFather = this.$data.listItemSelected.filter(grandFather => grandFather.idNTipoElemento === item.idNTipoElemento);
                if (grandFather.length > 0) {
                    //Check si la variable es un ñieto del abuelo
                    const variable = grandFather[0].variables.filter(v => v.id === item.id);

                    if (variable.length > 0) {
                        //Debemos actualizar 
                        let itemsSelected = JSON.parse(JSON.stringify(this.$data.listItemSelected));                     
                        
                        itemsSelected.forEach(grandFather => {
                            if (grandFather.idNTipoElemento === item.idNTipoElemento) {
                                grandFather.variables.forEach(v => {
                                    if (v.id === item.id) {
                                        
                                        v.deleted = item.deleted;
                                        v.modified = item.modified;
                                        return;
                                    }
                                })
                            }
                        });   

                        this.$data.listItemSelected = JSON.parse(JSON.stringify(itemsSelected));
                    }
                    else {
                        this.$data.listItemSelected.forEach(grandFather => {
                            if (grandFather.idNTipoElemento === item.idNTipoElemento) {
                                grandFather.variables.push(item);
                                return;
                            }
                        })
                    }

                    
                }
                else {
                    //Si el Abuelo NO EXISTE
                    const jsonPost = {
                        idNTipoElemento: item.idNTipoElemento, //id del abuelo
                        name: nameGrandFather,
                        path: pathName,
                        variables: [item], //ñietos
                        active: false
                    }
                    this.$data.listItemSelected.push(jsonPost);
                }
            }

            for (const node of arrayObject) {
                if (node.children && Array.isArray(node.children)) {
                    this.recursiveAddVariable(node.children, item, nameGrandFather, pathName);
                }
            }
        }

        /**
        * Wizard. Agrega un ELEMENTO 
        * @param arrayObject
        * @param item
        */
        recursiveAddElemento(arrayObject, item) {

            const objElemen = arrayObject.find(elem => elem.level === 2 && elem.id === item.id);
            if (objElemen) {
                         

                //Buscar el ELEMENTO SI ESTA AGREGADO AL LADO DERECHO
                const grandFather = this.$data.listItemSelected.filter(grandFather => grandFather.idNTipoElemento === item.id);
                if (grandFather.length > 0) {

                    this.$data.listItemSelected.filter(grandFather => {
                        if (grandFather.idNTipoElemento === item.id) {                            
                            grandFather.name = item.nameNew;
                            grandFather.deleted = item.deleted;
                            grandFather.modified = item.modified;
                            grandFather.original = item.original;
                        }
                    });
                }
                else {
                    //Si el Abuelo NO EXISTE
                    const jsonPost = {
                        idNTipoElemento: item.id, //id del abuelo
                        name: item.nameNew,
                        path: objElemen.path,
                        variables: [], //ñietos                      
                        deleted: item.deleted,
                        modified: item.modified,
                        active: false,
                        original:item.original
                    }
                    this.$data.listItemSelected.push(jsonPost);
                   
                }
            }

            for (const node of arrayObject) {
                if (node.children && Array.isArray(node.children)) {
                    this.recursiveAddElemento(node.children, item);
                }
            }
        }

        addVariable() {
            if (this.$refs.formAddVariable != null) {
                if (!this.$refs.formAddVariable.validate()) {
                    return;
                }
                //Copia de Seleccion Variables Original a una copia
                if (this.$data.selectionVariablesOriginal.length === 0) {
                    this.$data.selectionVariablesOriginal = JSON.parse(JSON.stringify(this.$props.selectionVariables));
                }

                const itemGrandFather = {
                    id: this.$data.itemVariable.idNTipoElemento
                };
                //copia por valor de selectionVariables
                const selectionVariables = JSON.parse(JSON.stringify(this.$props.selectionVariables));  
                
                if (this.$data.itemVariable.level === 2) {
                    //Modificando o eliminando un ELEMENTO        
                    this.$data.itemVariable.modified = true;
                    this.$data.itemVariable.deleted = false;                    
                    this.recursiveAddElemento(selectionVariables, this.$data.itemVariable);
                }
                else {
                    const nodeGrandFather = this.searchNodeGrandFather(selectionVariables, itemGrandFather);
                    //Modificando o eliminando una VARIABLE
                    this.recursiveAddVariable(selectionVariables, this.$data.itemVariable, nodeGrandFather.name, nodeGrandFather.path);
                }
                

                this.$data.itemVariable.name = this.$data.itemVariable.nameNew;                 
                this.$data.itemVariable.modified = true;   
                this.$data.dialogAddVariable = false;               
            }
        }
        /**
         * Wizard
         * Remove un item de la lista de variables seleccionadas del lado derecho (Abuelos/ñietos)
         * @param item
         */
        removeItem(item) {    
            //Copia de Seleccion Variables Original a una copia
            if (this.$data.selectionVariablesOriginal.length === 0) {
                this.$data.selectionVariablesOriginal = JSON.parse(JSON.stringify(this.$props.selectionVariables));
            }
            item.deleted = true;
            item.modified = false;
            item.nameNew = item.name;
            const selectionVariables = JSON.parse(JSON.stringify(this.$props.selectionVariables));

            if (item.level === 2) {
                //Eliminar Elementos y Variables
                //1. Marcar Todas las Variables con flag Delete
                this.setFlagDeleteAllVariable(this.$props.selectionVariables,item.id);

                //2. Mover Abuelo y Variable a la Derecha

            }
            else {
                //Eliminar solo Variables
                const itemGrandFather = {
                    id: item.idNTipoElemento
                };
            
                const nodeGrandFather = this.searchNodeGrandFather(selectionVariables, itemGrandFather);
                this.recursiveAddVariable(selectionVariables, item, nodeGrandFather.name, nodeGrandFather.path);
            }

        }

        /**
         * Setear todas las variables del Tipo de Elemento en el flag deleted=true
         * @param arrayObject
         * @param idNTipoElemento
         */
        setFlagDeleteAllVariable(arrayObject, idNTipoElemento) {
            const objElemen = arrayObject.find(elem => elem.level === 2 && elem.id === idNTipoElemento);
            if (objElemen) {
                let variables = [];
                objElemen.children.forEach(father => {
                    father.children.forEach(variable => {
                        variable.deleted = true;
                        variable.modified = false;                        
                        variables.push(variable);
                    });
                    
                    
                });  
                const grandFathers = this.$data.listItemSelected.filter(grandFather => grandFather.idNTipoElemento === idNTipoElemento);
                if (grandFathers.length > 0) {
                    this.$data.listItemSelected = this.$data.listItemSelected.filter(grandFather => grandFather.idNTipoElemento !== idNTipoElemento);
                }

                //Si el Abuelo NO EXISTE
                const jsonPost = {
                    idNTipoElemento: idNTipoElemento, //id del abuelo
                    name: objElemen.name,
                    path: objElemen.path,
                    variables: variables, //ñietos
                    deleted: true,
                    modified: false,
                    active: false
                }


                this.$data.listItemSelected.push(jsonPost);
            }

            for (const node of arrayObject) {
                if (node.children && Array.isArray(node.children)) {
                    this.setFlagDeleteAllVariable(node.children, idNTipoElemento);
                }
            }
        }

        /**
        * Wizard
        * Cancelar la edición o borrado de una variable
        * */
        cancelEdicionVariable(item) {
            //Sacar el item from listItemSelected
           
            this.$data.listItemSelected.forEach(grandFather => {
                const variablesFiltered = grandFather.variables.filter(p => p.id != item.id);
                grandFather.variables = variablesFiltered;                
            });
            const elemenWithVariableEmpty =  this.$data.listItemSelected.filter(grandFather => grandFather.variables.length === 0);
            this.$data.listItemSelected = this.$data.listItemSelected.filter(grandFather => grandFather.variables.length > 0);

            //Iterar sobre variables del lado izquierdo para resetear el valor

            let variables = JSON.parse(JSON.stringify(this.$props.selectionVariables));
            this.resetVariableRecursive(variables, item); 

            if (elemenWithVariableEmpty.length>0) {               
                //Setear elemento cuando variables esten todas canceladas                   
                this.resetOnlyElementoRecursive(variables, item);
            }


            this.$props.selectionVariables = JSON.parse(JSON.stringify(variables));
           
        }

        resetOnlyElementoRecursive(arrayObject, item) {

            const objElemen = arrayObject.find(elem => elem.level === 2 && elem.id === item.idNTipoElemento);
            if (objElemen) {
                objElemen.deleted = false;
                objElemen.modified = false;               
            }

            for (const node of arrayObject) {
                if (node.children && Array.isArray(node.children)) {
                    this.resetOnlyElementoRecursive(node.children, item);
                }
            }
        }

        /**
        * Wizard
        * Cancelar la edición o borrado de una variable
        * */
        cancelEdicionElemento(item) {
            //Sacar el item from listItemSelected         
            this.$data.listItemSelected = this.$data.listItemSelected.filter(elementos => elementos.id!==item.id);

            //Iterar sobre variables del lado izquierdo para resetear el valor            
            let variables = JSON.parse(JSON.stringify(this.$props.selectionVariables));
          
            this.resetElementoRecursive(variables, item);
            this.$props.selectionVariables = JSON.parse(JSON.stringify(variables));

        }

        resetElementoRecursive(arrayObject, item) {

            const objElemen = arrayObject.find(elem => elem.level === 2 && elem.id === item.idNTipoElemento);
            if (objElemen) {
                objElemen.deleted = false;
                objElemen.modified = false;
                if (item.modified) {
                    objElemen.name = item.original;
                }
                if (item.deleted) {
                    //Si el Elemento esta deleted, resetear todas las variables 
                    objElemen.children.forEach(father => {
                        father.children.forEach(variable => {
                            variable.deleted = false;
                            variable.modified = false;                            
                        });
                    });  
                }
            }

            for (const node of arrayObject) {
                if (node.children && Array.isArray(node.children)) {
                    this.resetElementoRecursive(node.children, item);
                }
            }
        }

        resetVariableRecursive(arrayObject, item) {

            const objElemen = arrayObject.find(elem => (elem.level === 4 || elem.level === 2) && elem.id === item.id);
            if (objElemen) {
                objElemen.deleted = false;
                objElemen.modified = false;
                if (item.modified) {
                    objElemen.name = item.original;
                }
            }

            for (const node of arrayObject) {
                if (node.children && Array.isArray(node.children)) {
                    this.resetVariableRecursive(node.children, item);
                }
            }
        }
        /**
         * Enviar set datos al backend para realizar el impacto en BD de las variables editas/borradas
         * 
         * */
        async saveDataVariables() {
            let vbles = [];
            this.$data.listItemSelected.forEach(p => {
                vbles.push(p.variables);
            });
            let result = [];
            vbles.forEach(v => {
                v.forEach(a => {
                    result.push(a);
                })
            })

            const data = await new VariableService().editElementVariable(this.$props.idNSupervisor, this.$data.listItemSelected);
            if (data.success) {
                this.$data.listItemSelected = [];
                this.$props.idNSupervisor = null;               
                this.$props.selectionVariables = [];
                this.$data.dialogConfirmSaveVariables = false;
                this.sendMessageToParent();                
                this.showSuccess('Los cambios fueron guardados con exito');
            } else {
                this.$data.dialogConfirmSaveVariables = false;
                this.showError('Ocurrio un error al guardar las variables: ' + data.error);
            }
        }

        reglaNameNew = [
            v => !!v || 'Debe ingresar un nombre',
        ];
    }
</script>
